// PATCH /stock-mapping/mapping/move-location ตอบ 200 แม้บาง item ไม่สำเร็จ ต้องดู status รายตัว
// success = ย้ายแล้ว, insufficient = ต้นทางไม่พอ (ไม่มีอะไรเปลี่ยน), error = เขียนปลายทางพลาด (คืนของต้นทางแล้ว)
export const getMoveErrorMessage = (results = []) => results
  .filter((result) => result.status !== 'success')
  .map((result) => {
    if (result.status === 'insufficient') {
      return `${result.code} : จำนวนในต้นทางไม่พอ (คงเหลือ ${result.availableQty || 0})`
    }
    return `${result.code} : ย้ายไม่สำเร็จ กรุณาลองใหม่`
  })
  .join(', ')

export default {
  getMoveErrorMessage
}
